import { LOAN_ACTION_CONDITION_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const loanActionsConditionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_ACTION_CONDITION_ACTION_TYPE.GET_LOAN_ACTIONS_CONDITIONS:
      return payload || state;

    default:
      return state;
  }
};

export default loanActionsConditionsReducer;
